import React from "react";
import { Modal } from "react-bootstrap";
import { wdType } from "./common";
// import wdTypeInfoImage from "../../static/images/wdtypeinfobox.png"

const WdTypeInfoBox = (props) => {
	if (props.wdType === wdType.WDT_CITY_TOUR) {
		return (
			<Modal show={props.show} onHide={props.hideModal} dialogClassName="modal-m modal-dialog modal-text">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>
						Thuê xe di chuyển <br /> Nội thành
					</h5>
				</Modal.Header>
				<Modal.Body>
					<div className="modal-text-body modal-wd-delivery-body">
						<div className="block-content">
							<p className="body-title">Giới thiệu</p>
							<p>Tài xế sẽ đón và đưa bạn di chuyển đến các địa điểm trong cùng thành phố, hoặc lân cận.</p>
							<p>Bạn chỉ cần nhập Điểm đón, sau đó trao đổi lộ trình mong muốn với Tài xế.</p>
						</div>
						<div className="block-content">
							<p className="body-title">Giá thuê</p>
							<p>
								Giá thuê của chuyến đi được tính theo thời gian bạn lựa chọn trên ứng dụng, đã bao gồm tiền tài xế, xăng
								xe, phí qua đêm, phục vụ chở khách tại điểm đến. Chưa bao gồm phí cầu đường, bến bãi,...
							</p>
						</div>
						<div className="block-content">
							<p className="body-title">Thời gian và số KM được di chuyển</p>
							<p>
								Sẽ thay đổi tùy thuộc vào lộ trình bạn lựa chọn trên ứng dụng. Trường hợp bạn cần đi thêm giờ hoặc thêm
								KM, bạn sẽ thanh toán phụ phí trực tiếp cho tài xế theo biểu phí ghi tại phần thông tin lộ trình thuê
								xe.
							</p>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		);
	} else if (props.wdType === wdType.WDT_ONEWAY) {
		return (
			<Modal show={props.show} onHide={props.hideModal} dialogClassName="modal-m modal-dialog modal-text">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>
						Thuê xe di chuyển <br /> Liên tỉnh - 1 chiều
					</h5>
				</Modal.Header>
				<Modal.Body>
					<div className="modal-text-body modal-wd-delivery-body">
						<div className="block-content">
							<p className="body-title">Giới thiệu</p>
							<p>
								Thuê xe liên tỉnh 1 chiều là dịch vụ dành cho khách hàng muốn di chuyển liên tỉnh (ví dụ từ TPHCM/ Hà
								Nội đến các tỉnh lân cận).
							</p>
							<p>
								Bạn vui lòng xác định trước lộ trình bao gồm Điểm đón và (các) Điểm đến. Tài xế sẽ đi cùng bạn trong
								suốt hành trình, chuyến đi sẽ kết thúc tại điểm đến cuối cùng của lộ trình bạn đã chọn trên ứng dụng.
							</p>
						</div>
						<div className="block-content">
							<p className="body-title">Giá thuê</p>
							<p>
								Giá thuê của chuyến đi được tính theo thời gian và lộ trình (1 chiều đi) mà bạn lựa chọn trên ứng dụng.
								Giá đã bao gồm tiền tài xế, xăng xe, phí qua đêm, phục vụ chở khách tại điểm đến. Chưa bao gồm phí cầu
								đường, bến bãi,...
							</p>
						</div>
						<div className="block-content">
							<p className="body-title">Thời gian và số KM được di chuyển</p>
							<p>
								Sẽ thay đổi tùy thuộc vào lộ trình bạn lựa chọn trên ứng dụng. Trường hợp bạn cần đi thêm giờ hoặc thêm
								KM vượt mức, bạn sẽ thanh toán phụ phí trực tiếp cho tài xế theo biểu phí ghi tại phần thông tin lộ
								trình thuê xe.
							</p>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		);
	} else {
		return (
			<Modal show={props.show} onHide={props.hideModal} dialogClassName="modal-m modal-dialog modal-text">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>
						Thuê xe di chuyển <br /> Liên tỉnh - 2 chiều
					</h5>
				</Modal.Header>
				<Modal.Body>
					<div className="modal-text-body modal-wd-delivery-body">
						<div className="block-content">
							<p className="body-title">Giới thiệu</p>
							<p>
								Thuê xe liên tỉnh 2 chiều là dịch vụ dành cho khách hàng muốn di chuyển liên tỉnh (ví dụ từ TPHCM/ Hà
								Nội đến các tỉnh lân cận).
							</p>
							<p>
								Bạn vui lòng xác định trước lộ trình bao gồm Điểm đón và (các) Điểm đến. Tài xế sẽ đi cùng bạn trong
								suốt hành trình, sau đó sẽ đưa bạn về lại Điểm đón bạn đã chọn trên ứng dụng.
							</p>
						</div>
						<div className="block-content">
							<p className="body-title">Giá thuê</p>
							<p>
								Giá thuê của chuyến đi được tính theo thời gian và lộ trình (2 chiều đi và về) mà bạn lựa chọn trên ứng
								dụng. Giá đã bao gồm tiền tài xế, xăng xe, phí qua đêm, phục vụ chở khách tại điểm đến. Chưa bao gồm phí
								cầu đường, bến bãi,...
							</p>
						</div>
						<div className="block-content">
							<p className="body-title">Thời gian và số KM được di chuyển</p>
							<p>
								Sẽ thay đổi tùy thuộc vào lộ trình bạn lựa chọn trên ứng dụng. Trường hợp bạn cần đi thêm giờ hoặc thêm
								KM vượt mức, bạn sẽ thanh toán phụ phí trực tiếp cho tài xế theo biểu phí ghi tại phần thông tin lộ
								trình thuê xe.
							</p>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		);
	}
	return null;
};

export default WdTypeInfoBox;
